/**
 * The extensions Mezz Proxy accepts — kept in step with its `$.key` regexFilter in services.json, which
 * media-file-name.spec.ts checks — so a preview is offered exactly where a proxy can be made.
 */
export const PROXYABLE_MEDIA_EXTENSIONS = ['mov', 'mp4', 'm4v', 'mxf', 'ts', 'mpg', 'jpg', 'jpeg', 'png', 'wav'];

export function isProxyableMediaFileName(fileName: string): boolean {
	const lastDotIndex = fileName.lastIndexOf('.');
	if (lastDotIndex <= 0) return false;
	return PROXYABLE_MEDIA_EXTENSIONS.includes(fileName.slice(lastDotIndex + 1).toLowerCase());
}
